import { isNonEmptyString } from 'utils/text';

export const isStringOverCharLimit = (string, charLimit) => isNonEmptyString(string) && string.length > charLimit;

export const isValidStaffTitle = title => !isStringOverCharLimit(title, 140);

export const hasInvalidSchedulingDeadline = appointmentPreferences => !!appointmentPreferences
    && appointmentPreferences.deadLineType === 'HOURS_BEFORE' && !appointmentPreferences.deadLineValue['HOURS_BEFORE'];


